import {
    Box,
    FormControl,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
    Typography
} from "@mui/material";
import {
    Page,
    usePageNavigation
} from "./contexts/PageNavigationContextProvider";

import { useIssueFilter } from "./contexts/IssueFilterContext";

export type ViewType = "Calendar" | "List" | "Table";
const views: ViewType[] = ["Calendar", "List", "Table"];

export const PageToViewType = {
    [Page.Dashboard]: "Calendar",
    [Page.Issues]: "List",
    [Page.Table]: "Table"
};

type ViewSwitcherProps = {
    disabled?: boolean;
};

export const ViewSwitcher = (props: ViewSwitcherProps) => {
    const { disabled } = props;

    const { currentPage, navigateToPage } = usePageNavigation();

    const { updateFilter } = useIssueFilter();

    const handleChange = (event: SelectChangeEvent<string>) => {
        updateFilter({});
        switch (event.target.value) {
            case "Calendar":
                navigateToPage(Page.Dashboard, new URLSearchParams(), false);
                break;
            case "List":
                navigateToPage(Page.Issues, new URLSearchParams(), false);
                break;
            case "Table":
                navigateToPage(Page.Table, new URLSearchParams(), false);
                break;
            default:
                console.error(`Unknown view: ${event.target.value}`);
        }
    };

    return (
        <Box display="flex" gap={1}>
            <Typography variant="body1" alignContent="center" fontWeight="500" fontSize="14px">View: </Typography>
            <FormControl
                sx={{
                    minWidth: 120,
                    border: theme => `1px solid ${disabled ? theme.palette.divider : "black"}`,
                    borderRadius: "4px",
                    "&:hover": {
                        borderColor: "black",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                }}
                disabled={disabled}
            >
                <Select sx={{ height: 36 }}
                    input={<OutlinedInput notched={false} />}
                    value={PageToViewType[currentPage]}
                    onChange={handleChange}
                    displayEmpty
                >
                    {views.map((view) => (
                        <MenuItem key={view} value={view} disabled={view === PageToViewType[currentPage]}>
                            <Typography
                                fontWeight="500"
                                fontSize="14px"
                                variant="body1"
                                alignContent="center"
                            >
                                {view}
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};
